function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import rison from 'rison-node';
import { Translate } from "../I18N";
import { MarkdownLink, SearchBox, MarkdownMedia, ItemList } from "./components";
import CustomHookComponents from "./CustomHooks";

import markdownToReact from "./markdownToReact";

class MarkdownViewer extends Component {
  static errorHtml(index, message) {
    return /*#__PURE__*/(
      _jsx("p", { className: "error" }, index, /*#__PURE__*/
      _jsx("br", {}), /*#__PURE__*/
      _jsx("strong", {}, void 0, /*#__PURE__*/
      _jsx("i", {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "Custom component error" }, void 0, "Custom component markup error: unsupported values! Please check your configuration"

      )
      )
      ), /*#__PURE__*/
      _jsx("br", {}),
      message, /*#__PURE__*/
      _jsx("br", {})
      ));

  }

  static customHook(config, index) {
    const props = rison.decode(config);
    if (!CustomHookComponents[props.component]) {
      throw new Error('Invalid  component');
    }
    const Element = CustomHookComponents[props.component];
    return /*#__PURE__*/React.createElement(Element, _extends({}, props, { key: index }));
  }

  inlineComponent(type, config, index) {
    const { compact } = this.props;
    let result;
    if (type === 'list') {
      result = this.list(config, index);
    }

    if (type === 'link') {
      result = /*#__PURE__*/React.createElement(MarkdownLink, _extends({}, rison.decode(config), { key: index }));
    }

    if (type === 'searchbox') {
      result = /*#__PURE__*/React.createElement(SearchBox, _extends({}, rison.decode(config), { key: index }));
    }

    if (['vimeo', 'youtube', 'media'].includes(type)) {
      result = /*#__PURE__*/
      _jsx("div", {}, index, /*#__PURE__*/
      _jsx(MarkdownMedia, { config: config, compact: compact }, index)
      );

    }

    if (type === 'customhook') {
      result = MarkdownViewer.customHook(config, index);
    }
    return result;
  }

  customComponent(type, config, index, children) {
    try {
      if (typeof type === 'function' || typeof type === 'object') {
        const Element = type;
        return /*#__PURE__*/(
          React.createElement(Element, _extends({}, config, { key: index }),
          children
          ));

      }

      if (type) {
        return this.inlineComponent(type, config, index);
      }
    } catch (error) {
      return MarkdownViewer.errorHtml(index, error.message);
    }

    return false;
  }

  list(_config, index) {
    const listData = this.props.lists[this.renderedLists] || {};
    const output = /*#__PURE__*/
    _jsx(ItemList, {

      link: `/library/${listData.params}`,
      items: listData.items,
      options: listData.options }, index
    );

    this.renderedLists += 1;
    return output;
  }

  render() {
    this.renderedLists = 0;

    if (typeof this.props.markdown !== 'string') {
      return false;
    }

    const ReactFromMarkdown = markdownToReact(
      this.props.markdown,
      this.customComponent.bind(this),
      this.props.html
    );

    if (!ReactFromMarkdown) {
      return false;
    }

    return /*#__PURE__*/_jsx("div", { className: "markdown-viewer" }, void 0, ReactFromMarkdown);
  }
}

MarkdownViewer.defaultProps = {
  lists: [],
  markdown: '',
  html: false,
  compact: false
};








export default MarkdownViewer;